/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreProductDataLabelsFromJSON, FxIdApplicationStoreProductDataLabelsToJSON, } from './FxIdApplicationStoreProductDataLabels';
import { FxIdDomainStoreEnumsStoreProductTypeFromJSON, FxIdDomainStoreEnumsStoreProductTypeToJSON, } from './FxIdDomainStoreEnumsStoreProductType';
/**
 * Check if a given object implements the FxIdApplicationStoreProductData interface.
 */
export function instanceOfFxIdApplicationStoreProductData(value) {
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('ProductName' in value) || value['ProductName'] === undefined)
        return false;
    if (!('ProductDescription' in value) || value['ProductDescription'] === undefined)
        return false;
    if (!('LocalizedProductName' in value) || value['LocalizedProductName'] === undefined)
        return false;
    if (!('LocalizedProductDescription' in value) || value['LocalizedProductDescription'] === undefined)
        return false;
    if (!('ProductType' in value) || value['ProductType'] === undefined)
        return false;
    if (!('Quantity' in value) || value['Quantity'] === undefined)
        return false;
    if (!('ImageUrl' in value) || value['ImageUrl'] === undefined)
        return false;
    if (!('IconUrl' in value) || value['IconUrl'] === undefined)
        return false;
    if (!('ShowInWebStore' in value) || value['ShowInWebStore'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreProductDataFromJSON(json) {
    return FxIdApplicationStoreProductDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreProductDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Sku': json['Sku'],
        'ProductName': json['ProductName'],
        'ProductDescription': json['ProductDescription'],
        'LocalizedProductName': json['LocalizedProductName'],
        'LocalizedProductDescription': json['LocalizedProductDescription'],
        'ProductType': FxIdDomainStoreEnumsStoreProductTypeFromJSON(json['ProductType']),
        'Labels': json['Labels'] == null ? undefined : FxIdApplicationStoreProductDataLabelsFromJSON(json['Labels']),
        'Payload': json['Payload'] == null ? undefined : json['Payload'],
        'Quantity': json['Quantity'],
        'ImageUrl': json['ImageUrl'],
        'IconUrl': json['IconUrl'],
        'ShowInWebStore': json['ShowInWebStore'],
        'RequiresDryRun': json['RequiresDryRun'] == null ? undefined : json['RequiresDryRun'],
    };
}
export function FxIdApplicationStoreProductDataToJSON(json) {
    return FxIdApplicationStoreProductDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreProductDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Sku': value['Sku'],
        'ProductName': value['ProductName'],
        'ProductDescription': value['ProductDescription'],
        'LocalizedProductName': value['LocalizedProductName'],
        'LocalizedProductDescription': value['LocalizedProductDescription'],
        'ProductType': FxIdDomainStoreEnumsStoreProductTypeToJSON(value['ProductType']),
        'Labels': FxIdApplicationStoreProductDataLabelsToJSON(value['Labels']),
        'Payload': value['Payload'],
        'Quantity': value['Quantity'],
        'ImageUrl': value['ImageUrl'],
        'IconUrl': value['IconUrl'],
        'ShowInWebStore': value['ShowInWebStore'],
        'RequiresDryRun': value['RequiresDryRun'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreProductData.js.map